import { BatchPanelLayout } from './BatchAddDynamicFields.constants';

export const batchPanelLayerStyles = {
  position: 'fixed',
  inset: 0,
  pointerEvents: 'none',
  zIndex: ({ zIndex }) => zIndex.drawer,
};

export const batchPanelRndStyle = {
  pointerEvents: 'auto',
};

export const batchPanelPaperStyles = {
  width: `${BatchPanelLayout.WIDTH}px`,
  overflow: 'hidden',
};

export const batchPanelHeaderStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px 16px 0',
};

export const batchPanelTitleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: 'text.secondary',
  cursor: 'move',
  userSelect: 'none',
};

export const batchPanelFooterStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};
